import React from "react";
import { Route, Switch } from "react-router-dom";
import UserVerify from './UserVerifyyy'
 
import Dashboard from './Dashboard/index';
 
const App = ({match}) => (
    <div className="gx-main-content-wrapper">
       
        <Switch>
            
            <Route path={`/UserVerify/:token`} render={props => <UserVerify {...props} />} />
            <Route path={`${match.url}`} render={props => <Dashboard {...props} />} />
    </Switch>
  </div>
);

export default App;
